module.exports = "/img/_/_/_/assets/images/creeper/book/common//37.jpg?1b9c7a9e62f6f00a4b35ce40797d59c5";